const _contractValue = $('[name="ContractValue"]').val();

export default function () {
    createPercentTextBoxes();
    createCurrencyTextBoxes();
    // createDatePickers();
    // createTeamMemberAutocomplete();
    createDropDownLists();
}

/*AutoComplete*/
// const createTeamMemberAutocomplete = () => {
//     const $autoComplete = $('input.js-team-member-autocomplete');
//     if ($autoComplete.data('kendoAutoComplete')) return;
//     const autoCompleteData = new kendo.data.DataSource({
//         serverFiltering: false,
//         transport: {
//             read: {
//                 type: 'post',
//                 url: '/Forms/ProjectReview/TeamMemberAutoComplete?company=0'
//             }
//         }
//     });
//     autoCompleteData.fetch();
//     $autoComplete.kendoAutoComplete({
//         placeholder: 'Search Team Members...',
//         filter: 'contains',
//         dataSource: autoCompleteData,
//         width: '100%'
//     });
// }

/*Dropdown Lists*/
const createDropDownLists = () => {
    console.log("Creating DropdownLists...")
    const $bonusPlanRole = $('select.js-bonus-plan-role');
    if (!$bonusPlanRole.data('kendoDropDownList'))
        $bonusPlanRole.kendoDropDownList({
            dataSource: {
                transport: {
                    read: {
                        url: '/Operations/ProfitShare/GetBonusPlanRoles',
                        type: 'get',
                        dataType: 'json'
                    }
                }
            },
            dataTextField: 'name',
            dataValueField: 'id',
            optionLabel: 'Select role...'
        });

    const $bonusPotential = $('select.js-bonus-potential');
    if ($bonusPotential.length && !$bonusPotential.data('kendoDropDownList')) {
        let k_bonusPotential = $bonusPotential.kendoDropDownList().data('kendoDropDownList');
        const potentialValue = $('[name=BonusPotential]').data('value');
        k_bonusPotential.value(`${potentialValue}`);
    }
}

/*Percentage*/
const createPercentTextBoxes = () => {
    const $inputs = $('input.js-percent');

    $.each($inputs, function (index, ele) {
        if (!$(ele).data('kendoNumericTextBox')) {
            $(ele).kendoNumericTextBox({
                format: '##,#.00 \\%',
                spinners: false
            });
        }
    })
}

/*Currency*/
const createCurrencyTextBoxes = () => {
    const k_numericTextBox = $('.js-currency').kendoNumericTextBox({
        format: '{0:C2}',
        spinners: false
    }).data('kendoNumericTextBox');

    // k_numericTextBox.value(value);
}

/*Date picker*/
const createDatePickers = () => {
    const $datepickers = $('.js-datepicker');

    $.each($datepickers, function (i, e) {
        const k_datepicker = $(e).kendoDatePicker({
            format: 'MM/dd/yyyy'
        }).data('kendoDatePicker');

        if (!k_datepicker.value()) {
            k_datepicker.value('');
        }
    })
}
